import { apiGet } from '../../api'

export const get_application_events = () => {
  return apiGet({
    endpoint: `events/applications_events`
  })
}
